export default class ResetPasswordModel {
    email = ""
}